import { makeStyles, createStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(({ palette, spacing, shape, breakpoint }) => createStyles({
    root: {
        marginTop: spacing(5),
    },
    main: {
        background: palette.primary.white,
        padding: spacing(4),
        marginTop: spacing(4),
        borderRadius: spacing(4),
        position: "relative"
    },
    block: {
        padding: `${spacing(4)}px 0`,
        background: palette.primary.white,
        width: "calc(33% - 9px)",
        borderRadius: spacing(1),
        marginBottom: spacing(2),
        marginRight: spacing(2),
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "flex-start",
        minHeight: 360,
        "&:nth-child(3n+3)": {
            marginRight: 0
        },
    },
    blockText: {
        width: '100%'
    },
    blockTitle: {
        width: '100%',
        marginTop: spacing(3),
        marginBottom: spacing(2),
        fontSize: '20px',
    },
    imgBlock: {
        width: "100%",
        borderRadius: spacing(1),
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: `0 ${spacing(4)}px`,
        marginBottom: spacing(3),

    },
    imgBlockReleased: {

    },
    blockImg: {
        maxHeight: 160
    },
    ml8: {
        marginLeft: spacing(1)
    },
    readMore: {
        cursor: 'pointer',
        display: "flex",
        padding: `0 ${spacing(4)}px`,
        alignItems: "center",
    },
    readMoreReleased: {
    },
    openDialogSection: {
        padding: `21px ${spacing(4)}px 0 0`,
        cursor: 'pointer',
        display: "flex",
        alignItems: "center",
        width: "100%",
        borderTop: `1px solid ${palette.text.backgroundMain}`,
        marginLeft: spacing(4),
        "&:hover $mono": {
            color: palette.secondary.dark
        },
    },
    shTitle: {
        marginTop: spacing(2),
        maxWidth: 727
    },
    shSubtitle: {
        marginTop: spacing(2)
    },
    shButton: {
        marginTop: spacing(3),
        background: palette.primary.dark
    },
    freeUserRoot: {
        background: palette.common.white,
        borderRadius: spacing(3),
        padding: "64px 0 78px 0",
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
    },
    flexWrap: {
        display: "flex",
        flexWrap: "wrap"
    },
    benefitsCardsWrapper: {
        background: palette.primary.white,
        borderRadius: spacing(3),
        marginBottom: spacing(6),
        paddingRight: spacing(10),
        paddingLeft: spacing(10),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    benefitsCardsWrapperTitle: {
        height: '56px',
        background: palette.primary.backgroundLight,
        width: '100%',
        borderRadius: `${spacing(3)}px ${spacing(3)}px 0 0`,
        textAlign: 'center',
        lineHeight: '56px',
        fontSize: '14px'
    },
    benefitsCard: {
        background: palette.common.white,
        width: '100%',
        borderBottom: `1px solid ${palette.text.lightest}`,
        borderLeft: `1px solid ${palette.text.lightest}`,
        borderRight: `1px solid ${palette.text.lightest}`,
        maxHeight: "none",
        paddingTop: spacing(1),
    },
    lockIcon: {
        position: "absolute",
        right: 48,
        top: 173,
    },
    mono: {
        fontFamily: "GT Flexa Mono, sans-serif"
    },
    questionMark: {
        marginRight: spacing(2),
    },
    imgWrapper: {
        background: palette.primary.backgroundLight,
        width: "100%",
        height: 160,
        borderRadius: spacing(1),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    descriptionExpanded: {
        maxHeight: "none",
        paddingBottom: spacing(4)
    },
    description: {
        overflowY: "hidden",
        textOverflow: "ellipsis",
        width: "100%",
    },
    descriptionBox: {
        paddingRight: spacing(4),
        position: "relative"
    },
    showMore: {
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        cursor: "pointer",
        textAlign: "center",
        paddingTop: spacing(4),
        background: `linear-gradient(180.03deg, rgba(255, 248, 243, 0) 20%, #FFFFFF 80%)`,
        "&::before": {
            content: '""',
            position: "absolute",
            bottom: 9,
            left: 0,
            width: "42%",
            height: 1,
            background: palette.text.backgroundMain
        },
        "&::after": {
            content: '""',
            position: "absolute",
            bottom: 9,
            right: 0,
            width: "42%",
            height: 1,
            background: palette.text.backgroundMain
        }
    },
    technologies: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: '100%'
    },
    placeholder: {
        height: '40vh',
        width: '100%',
        marginBottom: spacing(6),
        borderRadius: spacing(3),
        background: palette.text.backgroundMain,
    },
    placeholderItem: {
        width: '100%',
        height: '33%',
        textAlign: 'center',
        lineHeight: 10
    }
}));
